<template>
    <aside class="
        w-full h-fit bg-white text-white-foreground
        border border-white-foreground/10
        rounded-3xl md:w-[350px]"
        >
        <slot />
    </aside>
</template>
